import { getQuery } from 'client/utils/location';
import { REVIEWS_ALL, REVIEWS_PER_CLICK } from 'client/constants/dealer-reviews';

const getInitialReviewCount = ({ reviewsType, query, isInternalReferrer }) => {
  const hasReferrer = query.referrer === 'true' || isInternalReferrer;
  const seeReviews = query.seeReviews === 'true';
  const shouldShowReviews = hasReferrer || seeReviews || reviewsType !== REVIEWS_ALL;

  return { initialCount: shouldShowReviews ? REVIEWS_PER_CLICK : 0 };
};

export const getListInitialParams = (location, reviewsType, { isInternalReferrer = false } = {}) => {
  const query = getQuery(location);
  const { initialCount } = getInitialReviewCount({ reviewsType, query, isInternalReferrer });
  const pageNumber = parseInt(query?.page || 1, 10);

  return { initialCount, pageNumber };
};
